var _g, _g2, _g3, _path, _path2, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreLegalStudies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "compliant",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.593,
    height: 69.593,
    viewBox: "0 0 69.593 69.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46659",
    "data-name": "Group 46659",
    transform: "translate(3.581 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46655",
    "data-name": "Group 46655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46650",
    "data-name": "Group 46650",
    transform: "translate(0 4.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46642",
    "data-name": "Group 46642",
    transform: "translate(1.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46640",
    "data-name": "Group 46640",
    transform: "translate(0 1.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54220",
    "data-name": "Path 54220",
    d: "M46.363,45.612a1.019,1.019,0,0,0-1.8,0L33.883,65.9h2.3l9.274-17.621L54.735,65.9h2.3Z",
    transform: "translate(-33.883 -45.067)",
    fill: "#e8b800"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46641",
    "data-name": "Group 46641",
    transform: "translate(10.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54221",
    "data-name": "Path 54221",
    d: "M111.561,35.34H113.6V57.491h-2.039Z",
    transform: "translate(-111.561 -35.34)",
    fill: "#fac600"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46649",
    "data-name": "Group 46649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46643",
    "data-name": "Group 46643",
    transform: "translate(38.582 1.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54222",
    "data-name": "Path 54222",
    d: "M322.679,45.612a1.019,1.019,0,0,0-1.8,0L310.2,65.9h2.3l9.274-17.621L331.051,65.9h2.3Z",
    transform: "translate(-310.199 -45.067)",
    fill: "#e8b800"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46644",
    "data-name": "Group 46644",
    transform: "translate(49.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54223",
    "data-name": "Path 54223",
    d: "M387.878,35.34h2.039V57.491h-2.039Z",
    transform: "translate(-387.878 -35.34)",
    fill: "#fac600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46645",
    "data-name": "Group 46645",
    transform: "translate(0 22.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54224",
    "data-name": "Path 54224",
    d: "M26.407,198l2.744,4.753a.457.457,0,0,0,.4.228h18.8a.457.457,0,0,0,.4-.228L51.488,198a.457.457,0,0,0-.4-.685H26.8a.457.457,0,0,0-.4.685Z",
    transform: "translate(-26.345 -197.31)",
    fill: "#ca6e59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46646",
    "data-name": "Group 46646",
    transform: "translate(0 22.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54225",
    "data-name": "Path 54225",
    d: "M35.607,202.748,32.863,198a.457.457,0,0,1,.4-.685H26.8a.457.457,0,0,0-.4.685l2.744,4.753a.457.457,0,0,0,.4.228H36A.457.457,0,0,1,35.607,202.748Z",
    transform: "translate(-26.345 -197.31)",
    fill: "#bb5d4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46647",
    "data-name": "Group 46647",
    transform: "translate(37.558 22.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54226",
    "data-name": "Path 54226",
    d: "M302.724,198l2.744,4.753a.457.457,0,0,0,.4.228h18.8a.457.457,0,0,0,.4-.228L327.8,198a.457.457,0,0,0-.4-.685H303.119A.457.457,0,0,0,302.724,198Z",
    transform: "translate(-302.662 -197.31)",
    fill: "#ca6e59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46648",
    "data-name": "Group 46648",
    transform: "translate(37.558 22.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54227",
    "data-name": "Path 54227",
    d: "M312.721,202.748,309.977,198a.457.457,0,0,1,.4-.685h-7.254a.457.457,0,0,0-.4.685l2.744,4.753a.457.457,0,0,0,.4.228h7.254A.457.457,0,0,1,312.721,202.748Z",
    transform: "translate(-302.662 -197.31)",
    fill: "#bb5d4c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46651",
    "data-name": "Group 46651",
    transform: "translate(30.362 7.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54228",
    "data-name": "Path 54228",
    d: "M249.72,55.646v5.962h2.039V55.646a3.764,3.764,0,0,1-2.039,0Z",
    transform: "translate(-249.72 -55.646)",
    fill: "#883f2e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54229",
    "data-name": "Path 54229",
    d: "M242.192,125.02V99.209a.7.7,0,0,0-.7-.7h-4.21a.7.7,0,0,0-.7.7V125.02Z",
    transform: "translate(-208.006 -85.119)",
    fill: "#bb5d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54230",
    "data-name": "Path 54230",
    d: "M238.957,125.02V99.208a.7.7,0,0,1,.7-.7h-2.376a.7.7,0,0,0-.7.7v25.811h2.376Z",
    transform: "translate(-208.005 -85.118)",
    fill: "#a44f3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46652",
    "data-name": "Group 46652",
    transform: "translate(6.602 2.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54231",
    "data-name": "Path 54231",
    d: "M304.142,21.34H284.025a3.764,3.764,0,0,1,0,2.039h20.117a1.019,1.019,0,0,0,0-2.039Z",
    transform: "translate(-255.602 -21.34)",
    fill: "#bb5d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54232",
    "data-name": "Path 54232",
    d: "M95.91,22.359a3.773,3.773,0,0,1,.141-1.019H75.933a1.019,1.019,0,1,0,0,2.039H96.05A3.768,3.768,0,0,1,95.91,22.359Z",
    transform: "translate(-74.914 -21.34)",
    fill: "#bb5d4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46653",
    "data-name": "Group 46653",
    transform: "translate(27.461)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2742",
    "data-name": "Ellipse 2742",
    cx: 3.92,
    cy: 3.92,
    rx: 3.92,
    ry: 3.92,
    fill: "#883f2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46654",
    "data-name": "Group 46654",
    transform: "translate(27.461 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54233",
    "data-name": "Path 54233",
    d: "M231.881,3.92A3.919,3.919,0,0,1,234.051.413a3.92,3.92,0,1,0,0,7.014A3.919,3.919,0,0,1,231.881,3.92Z",
    transform: "translate(-228.38 0)",
    fill: "#6d3326"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46658",
    "data-name": "Group 46658",
    transform: "translate(19.503 39.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54234",
    "data-name": "Path 54234",
    d: "M222.155,298.708v-3.353a2.8,2.8,0,0,0-2.8-2.8h-7.49a2.8,2.8,0,0,0-2.8,2.8v3.353Z",
    transform: "translate(-203.731 -292.555)",
    fill: "#883f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54235",
    "data-name": "Path 54235",
    d: "M213.789,298.708v-3.353a2.8,2.8,0,0,1,2.8-2.8h-4.725a2.8,2.8,0,0,0-2.8,2.8v3.353Z",
    transform: "translate(-203.731 -292.555)",
    fill: "#6d3326"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46656",
    "data-name": "Group 46656",
    transform: "translate(0 6.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54236",
    "data-name": "Path 54236",
    d: "M193.588,342.179v-2.954a2.4,2.4,0,0,0-2.4-2.4H172.232a2.4,2.4,0,0,0-2.4,2.4v2.954Z",
    transform: "translate(-169.832 -336.825)",
    fill: "#bb5d4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46657",
    "data-name": "Group 46657",
    transform: "translate(0 6.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54237",
    "data-name": "Path 54237",
    d: "M175.737,342.179v-2.954a2.4,2.4,0,0,1,2.4-2.4h-5.905a2.4,2.4,0,0,0-2.4,2.4v2.954Z",
    transform: "translate(-169.832 -336.825)",
    fill: "#a44f3e"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46664",
    "data-name": "Group 46664",
    transform: "translate(1.019 52.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46662",
    "data-name": "Group 46662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54238",
    "data-name": "Path 54238",
    d: "M16.613,393.566v-7.106a3.608,3.608,0,0,1,3.6-3.6v-.136H14.794a7.294,7.294,0,1,0,0,14.587h5.423v-.136A3.609,3.609,0,0,1,16.613,393.566Z",
    transform: "translate(-7.5 -382.719)",
    fill: "#3675bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46660",
    "data-name": "Group 46660",
    transform: "translate(8.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54239",
    "data-name": "Path 54239",
    d: "M73.542,386.458v7.106a3.74,3.74,0,0,0,3.74,3.74h51.989V382.718H77.282A3.74,3.74,0,0,0,73.542,386.458Z",
    transform: "translate(-73.542 -382.718)",
    fill: "#fff3de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46661",
    "data-name": "Group 46661",
    transform: "translate(8.977 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54240",
    "data-name": "Path 54240",
    d: "M80.823,393.834a3.74,3.74,0,0,1-3.74-3.74v-7.106c0-.079,0-.157.008-.234a3.74,3.74,0,0,0-3.55,3.735v7.106a3.74,3.74,0,0,0,3.74,3.74h51.99v-3.5Z",
    transform: "translate(-73.541 -382.753)",
    fill: "#ffe5c2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46663",
    "data-name": "Group 46663",
    transform: "translate(39.936 3.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54241",
    "data-name": "Path 54241",
    d: "M326.085,409.615H302.334a1.019,1.019,0,1,0,0,2.039h23.751Z",
    transform: "translate(-301.315 -409.615)",
    fill: "#f6a96c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54242",
    "data-name": "Path 54242",
    d: "M326.085,448.139H302.334a1.019,1.019,0,1,0,0,2.039h23.751Z",
    transform: "translate(-301.315 -442.903)",
    fill: "#f6a96c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46665",
    "data-name": "Group 46665",
    transform: "translate(0 51.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54243",
    "data-name": "Path 54243",
    d: "M8.418,377.257H68.573a1.019,1.019,0,0,0,0-2.039H8.439a8.313,8.313,0,1,0-.126,16.626h7.075V389.8H8.313a6.274,6.274,0,1,1,.105-12.548Z",
    transform: "translate(0 -375.218)",
    fill: "#2263aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54244",
    "data-name": "Path 54244",
    d: "M167.477,482.536v2.039h45.809a1.019,1.019,0,1,0,0-2.039Z",
    transform: "translate(-144.713 -467.949)",
    fill: "#2263aa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54245",
    "data-name": "Path 54245",
    d: "M112.211,423.615v11.593a.42.42,0,0,0,.659.345l3.165-2.19,3.165,2.19a.42.42,0,0,0,.659-.345V423.615Z",
    transform: "translate(-96.959 -366.036)",
    fill: "#fb2b3a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54246",
    "data-name": "Path 54246",
    d: "M112.211,423.614v11.593a.42.42,0,0,0,.659.345l2.862-1.98v-9.958h-3.521Z",
    transform: "translate(-96.959 -366.035)",
    fill: "#e41f2d"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46666",
    "data-name": "Group 46666",
    transform: "translate(12.717 55.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54247",
    "data-name": "Path 54247",
    d: "M113.654,411.654H94.578a1.019,1.019,0,0,1,0-2.039h19.075a1.019,1.019,0,0,1,0,2.039Z",
    transform: "translate(-93.559 -409.615)",
    fill: "#f6a96c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreLegalStudies);
export default __webpack_public_path__ + "static/media/explore-legal-studies.27fd91d707d7d8384b254b6e3ac8adcc.svg";
export { ForwardRef as ReactComponent };